var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 52",
    style: {
      enableBackground: "new 0 0 20 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,15l-8.3,8.3C7.2,23.1,6.6,23,6,23c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6c0-0.6-0.1-1.2-0.3-1.7l1.6-1.6 v-1.3h1.3L20,19v-4H16z M18.7,18.4L14.1,23h-0.8H12v1.3v0.8l-1.2,1.2l-0.6,0.6l0.2,0.8c0.1,0.4,0.2,0.9,0.2,1.4 c0,2.6-2.1,4.7-4.7,4.7S1.3,31.6,1.3,29s2.1-4.7,4.7-4.7c0.5,0,0.9,0.1,1.4,0.2l0.8,0.2l0.6-0.6l7.9-7.9h2.1V18.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 4.7,
    cy: 30.3,
    r: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 19.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -9.4151 16.6027)",
    className: "st0",
    width: 5.7,
    height: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPassword);
export default __webpack_public_path__ + "static/media/i_password.b4c336ead1c4b6dd42b4f529b7b7a120.svg";
export { ForwardRef as ReactComponent };